"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find-index");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ActivitySelectionPopup = _interopRequireDefault(require("@/views/operationManagement/appRenovation/component/components/ActivitySelectionPopup.vue"));
var _activityResponse = _interopRequireDefault(require("@/components/ActivityResponse/activityResponse"));
var _member = require("@/api/member/member");
var _PushMessageCreation = require("@/api/messagePush/PushMessageCreation");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var cityOptions = [{
  name: '星期一',
  id: 1
}, {
  name: '星期二',
  id: 2
}, {
  name: '星期三',
  id: 3
}, {
  name: '星期四',
  id: 4
}, {
  name: '星期五',
  id: 5
}, {
  name: '星期六',
  id: 6
}, {
  name: '星期日',
  id: 7
}];
var _default = exports.default = {
  components: {
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  mixins: [_activityResponse.default],
  data: function data() {
    return {
      options: [],
      // 用户等级
      dialogVisible: false,
      // 会员选择弹窗

      Display_name: '',
      //	营销位名称
      ActivityName: '',
      //	活动名称
      ruleForm: {
        messageType: 0,
        //	推送类型 0-活动消息 1-系统消息
        targetType: 0,
        //	目标类型 0-所有人 1-指定等级 2-指定标签 3-指定个人
        messageTittle: '',
        //	通知标题
        messageContent: '',
        //	通知内容
        timeType: 0,
        //	推送时间 0-立即推送 1-定时推送 2-每天推送 3-每周推送

        targetGrades: [],
        // 选择的等级
        targetLevels: [],
        // 选择的等级
        memberIds: [],
        //	指定用户id
        url: '',
        fixHour: '',
        //
        startDate: '',
        //	开始日期
        endDate: '',
        // 结束日期
        releaseTime: '',
        // 投放时间
        releaseWeek: [] //	投放星期几
      },
      rules: {
        // messageType: [
        //   { required: true, message: '请选择推送类型', trigger: 'change' }
        // ],
        // targetType: [
        //   { required: true, message: '请选择目标类型', trigger: 'change' }
        // ],
        messageTittle: [{
          required: true,
          message: '请输入通知标题',
          trigger: 'blur'
        }],
        messageContent: [{
          required: true,
          message: '请输入通知内容',
          trigger: 'blur'
        }],
        region: [{
          required: true,
          message: '请选择活动区域',
          trigger: 'change'
        }],
        date1: [{
          type: 'date',
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        date2: [{
          type: 'date',
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        type: [{
          type: 'array',
          required: true,
          message: '请至少选择一个活动性质',
          trigger: 'change'
        }],
        resource: [{
          required: true,
          message: '请选择活动资源',
          trigger: 'change'
        }],
        desc: [{
          required: true,
          message: '请填写活动形式',
          trigger: 'blur'
        }]
      },
      loading: false,
      // loading
      queryData: {
        queryType: 1,
        memberListParam: {
          phone: '',
          // 手机号
          memberId: '',
          // 用户ID
          nickname: '' // 会员name
        },
        page: {
          page: 1,
          size: 10
        }
      },
      total: 0,
      // 条数
      tableData: [],
      // 会员列表数据
      memberIdObj: [],
      // 勾选数据集合（列表显示）
      preMemberIdObj: [],
      // 弹窗预选择

      cities: cityOptions,
      checkAll: false,
      isIndeterminate: true
    };
  },
  watch: {
    'ruleForm.url': function ruleFormUrl(newVal) {
      if (!newVal) {
        this.ActivityName = ''; // 清空 ActivityName
        this.Display_name = '';
      }
    }
  },
  created: function created() {
    this.memberQueryMemberGradeApi();
  },
  methods: {
    // 用户等级
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context.v;
              this.options = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }(),
    onChangeArgetTyp: function onChangeArgetTyp() {
      this.ruleForm.targetGrades = []; // 清空选择的等级
    },
    onSelectMember: function onSelectMember() {
      this.preMemberIdObj = JSON.parse(JSON.stringify(this.memberIdObj));
      this.memberQueryMemberListApi();
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.onInitQuery();
      this.dialogVisible = false;
    },
    onInquire: function onInquire() {
      this.memberQueryMemberListApi();
    },
    onInitQuery: function onInitQuery() {
      this.queryData = {
        queryType: 1,
        memberListParam: {
          phone: '',
          // 手机号
          memberId: '',
          // 用户ID
          nickname: '' // 会员name
        },
        page: {
          page: 1,
          size: 10
        }
      };
    },
    onInitialize: function onInitialize() {
      this.onInitQuery();
      this.memberQueryMemberListApi();
    },
    memberQueryMemberListApi: function () {
      var _memberQueryMemberListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              this.loading = true;
              _context2.n = 1;
              return (0, _member.memberQueryMemberListApi)(params);
            case 1:
              res = _context2.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.loading = false;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function memberQueryMemberListApi() {
        return _memberQueryMemberListApi2.apply(this, arguments);
      }
      return memberQueryMemberListApi;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.memberQueryMemberListApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.memberQueryMemberListApi();
    },
    // 勾选
    onAddMemberId: function onAddMemberId(data) {
      var exists = this.preMemberIdObj.some(function (item) {
        return item.memberId === data.memberId;
      });
      if (!exists) {
        this.preMemberIdObj.push({
          memberId: data.memberId,
          icon: data.icon,
          nickname: data.nickname,
          phone: data.phone
        });
      }
    },
    // 弹出按钮刪除
    onDelMemberId: function onDelMemberId(data) {
      var memberId = data.memberId;
      var index = this.preMemberIdObj.findIndex(function (item) {
        return item.memberId === memberId;
      });
      if (index !== -1) {
        this.preMemberIdObj.splice(index, 1);
      }
    },
    // 添加选中用户
    onAddUser: function onAddUser() {
      if (this.preMemberIdObj.length > 0) {
        this.memberIdObj = JSON.parse(JSON.stringify(this.preMemberIdObj));
        this.ruleForm.memberIds = this.preMemberIdObj.map(function (item) {
          return item.memberId;
        });
        this.onInitQuery();
        this.dialogVisible = false;
      } else {
        this.$message.warning('请先选择至少一位用户后再点击添加!');
      }
    },
    onListDelMemberId: function onListDelMemberId(data) {
      // 删除this.ruleForm.memberIds
      var memberId = data.memberId;
      var index = this.ruleForm.memberIds.indexOf(memberId);
      if (index !== -1) {
        this.ruleForm.memberIds.splice(index, 1); // 从数组中移除
      }

      // 删除memberIdObj
      var index1 = this.memberIdObj.findIndex(function (item) {
        return item.memberId === memberId;
      });
      if (index1 !== -1) {
        this.memberIdObj.splice(index, 1);
      }
    },
    // --------------------
    // 选择活动
    onOfficialEvent: function onOfficialEvent() {
      this.$refs.activitySelectionPopup.open();
    },
    // 自定义货多功能回传
    onSelectEvents: function onSelectEvents(data) {
      var resData = this.response(data);
      this.Display_name = data.Display_name;
      this.ruleForm.url = resData.openUrl;
      this.ActivityName = resData.name;
    },
    // ---------------------------------------------------
    onChangeTargetType: function onChangeTargetType() {
      this.ruleForm.fixHour = '';
      this.ruleForm.startDate = '';
      this.ruleForm.endDate = '';
      this.ruleForm.releaseTime = '';
      this.ruleForm.releaseWeek = [];
    },
    // handleCheckAllChange(val) {
    //   this.checkedCities = val ? cityOptions : []
    //   this.isIndeterminate = false
    // },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // alert('submit!')
          _this.saveMessagePlan();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.ruleForm = {
        messageType: 0,
        //	推送类型 0-活动消息 1-系统消息
        targetType: 0,
        //	目标类型 0-所有人 1-指定等级 2-指定标签 3-指定个人
        messageTittle: '',
        //	通知标题
        messageContent: '',
        //	通知内容
        timeType: 0,
        //	推送时间 0-立即推送 1-定时推送 2-每天推送 3-每周推送

        targetGrades: [],
        // 选择的等级
        targetLevels: [],
        // 选择的等级
        memberIds: [],
        //	指定用户id
        url: '',
        fixHour: '',
        //
        startDate: '',
        //	开始日期
        endDate: '',
        // 结束日期
        releaseTime: '',
        // 投放时间
        releaseWeek: [] //	投放星期几
      };
      this.memberIdObj = [];
      this.preMemberIdObj = [];
      this.$refs[formName].resetFields();
    },
    saveMessagePlan: function () {
      var _saveMessagePlan2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context3.n = 1;
              return (0, _PushMessageCreation.saveMessagePlan)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.resetForm('ruleForm');
                this.memberIdObj = [];
                this.preMemberIdObj = [];
                this.$message.success('操作成功');
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function saveMessagePlan() {
        return _saveMessagePlan2.apply(this, arguments);
      }
      return saveMessagePlan;
    }()
  }
};